import {Box, Typography} from "@mui/material";
import {IconChartHistogram, IconEye, IconLanguage, IconRoute, IconShieldCheck} from "@tabler/icons-react";
import {c, cardSx, purpleGradient} from "../landingTokens";
import {Section, Eyebrow, SectionHeading, Dim} from "./Shell";
import {ProductShot} from "./ProductShot";
import supervisionShot from "../../../assets/images/supervision.png";
import dashboardShot from "../../../assets/images/dashboard.png";

const SMALL = [
  {
    icon: IconLanguage,
    title: "Multilingual & 24/7",
    body: "English, Macedonian, Serbian and Croatian in production — and we train models for any language you need. Zero downtime, no global payroll.",
  },
  {
    icon: IconRoute,
    title: "Customizable workflows",
    body: "Tailor scripts, escalation paths and branding to the way your team already works.",
  },
  {
    icon: IconShieldCheck,
    title: "Security & compliance",
    body: "GDPR-aligned data handling, EU hosting options, call redaction and full audit trails.",
  },
];

const MEDIA = [
  {
    icon: IconEye,
    title: "Live supervision",
    body: "Watch every conversation as it happens, step in mid-call, redirect to an Avaya phone, and leave notes that feed straight back into the flow.",
    src: supervisionShot,
    alt: "Live supervision interface",
    ratio: "1802 / 872",
  },
  {
    icon: IconChartHistogram,
    title: "Analytics & insights",
    body: "Every call, intent and outcome rolled into live dashboards your team can actually act on.",
    src: dashboardShot,
    alt: "Analytics dashboard",
    ratio: "1789 / 879",
  },
];

const iconTileSx = {
  width: 46,
  height: 46,
  flexShrink: 0,
  display: "grid",
  placeItems: "center",
  borderRadius: "14px",
  background: purpleGradient,
  color: "#fff",
  boxShadow: "0 12px 24px -12px rgba(98,88,232,0.7)",
};

export const Capabilities = () => (
  <Section id="caps" label="Capabilities">
    <Eyebrow>Capabilities</Eyebrow>
    <SectionHeading sx={{mb: 6.5, maxWidth: 820}}>
      Powering the future of<br />
      <Dim>contact centers.</Dim>
    </SectionHeading>

    <Box className="reveal-stagger" sx={{display: "grid", gridTemplateColumns: {xs: "1fr", sm: "1fr 1fr", md: "repeat(6, 1fr)"}, gap: 2.25}}>
      {/* Top row — three compact capability cards */}
      {SMALL.map((item) => (
        <Box key={item.title} sx={{...cardSx, gridColumn: {md: "span 2"}}}>
          <Box sx={{...iconTileSx, mb: 2.25}}>
            <item.icon size={22} stroke={1.8} aria-hidden="true" />
          </Box>
          <Typography sx={{fontSize: 22, letterSpacing: "-0.02em", fontWeight: 600, mb: 1.25}}>{item.title}</Typography>
          <Typography sx={{fontSize: 15, lineHeight: 1.55, color: c.inkSoft}}>{item.body}</Typography>
        </Box>
      ))}

      {/* Bottom row — two feature cards that carry the product screenshots */}
      {MEDIA.map((item) => (
        <Box key={item.title} sx={{...cardSx, gridColumn: {md: "span 3"}, display: "flex", flexDirection: "column", gap: 3, overflow: "hidden"}}>
          <Box sx={{display: "flex", gap: 2, alignItems: "flex-start"}}>
            <Box sx={iconTileSx}>
              <item.icon size={22} stroke={1.8} aria-hidden="true" />
            </Box>
            <Box>
              <Typography sx={{fontSize: 22, letterSpacing: "-0.02em", fontWeight: 600, mb: 0.75}}>{item.title}</Typography>
              <Typography sx={{fontSize: 15, lineHeight: 1.55, color: c.inkSoft}}>{item.body}</Typography>
            </Box>
          </Box>
          <Box sx={{mt: "auto"}}>
            <ProductShot src={item.src} alt={item.alt} ratio={item.ratio} fit="contain" />
          </Box>
        </Box>
      ))}
    </Box>
  </Section>
);
